/* eslint-disable max-len */
/**
 * Checks if input value is `Async Function`.
 *
 * @func isAsyncFunction
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.5.0|v0.5.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {Boolean}
 * @see {@link RA.isFunction|isFunction}, {@link RA.isNotAsyncFunction|isNotAsyncFunction}, {@link RA.isGeneratorFunction|isGeneratorFunction}
 * @example
 *
 * RA.isAsyncFunction(async function test() { }); //=> true
 * RA.isAsyncFunction(null); //=> false
 * RA.isAsyncFunction(function test() { }); //=> false
 * RA.isAsyncFunction(() => {}); //=> false
 */
/* eslint-enable max-len */
var isAsyncFunction = function isAsyncFunction(val) {
  return Object.prototype.toString.call(val) === '[object AsyncFunction]';
};

export default isAsyncFunction;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda-adjunct/es/isAsyncFunction.js
// module id = 204
// module chunks = 0